import { Row, RowCenter } from "style/preset"
import styled, { css } from "styled-components"

import { ReactComponent as WarnSvg } from 'assets/svgs/waring_icon.svg' 
import StyledContainer from "style/styledContainer"
import { useCallback } from "react"
import { useAppSelector } from "hooks/redux/hooks"
import { Tooltip } from "react-tooltip"
import { ToolTipCom } from "./TransferInfoCom"

interface Props {
    btnFlag?: boolean
}

// 滑点模块
const SlippageWarnCom = ({btnFlag = false}: Props) => {
    const { slippage } = useAppSelector((state) => state.coreInfo)

    const checkSlippage = useCallback(() => {
        let level = 0;
        if(slippage < 5) return level
        if(slippage >= 5 &&  slippage < 10) {
            level = 1;
        } else if(slippage >= 10 &&  slippage < 20) {
            level = 2;
        } else {
            level = 3;
        }
        return level
    }, [slippage])

    return <>
        {
            slippage < 20 ? (
                btnFlag ? <></> : <StyledContainer>{slippage}%</StyledContainer>
            )
             : <SlippageWarnWrap $level={checkSlippage()}>
                <WarnSvgWrap></WarnSvgWrap>
                <WarnTextWrap>{btnFlag ? 'Slippage ~ ':''}{slippage}%</WarnTextWrap>
            </SlippageWarnWrap>
        }
    </>
}


// 价格差异模块
export const PriceImpactTagCom = () => {
    const { priceImpact: priceImpactStr } = useAppSelector((state) => state.coreInfo)
    const checkSlippage = useCallback(() => {
        let level = 0;
        const priceImpact = +priceImpactStr
        if(priceImpact < 5) return level
        if(priceImpact >= 5 &&  priceImpact < 10) {
            level = 1;
        } else if(priceImpact >= 10 &&  priceImpact < 20) {
            level = 2;
        } else {
            level = 3;
        }
        return level
    }, [priceImpactStr])
    return <>
        <PriceImpactTagWrap $level={checkSlippage()} data-tooltip-id="tootltip_price_impact">
            <StyledContainer $roobertSemiBold $mr="6px">Price impact:</StyledContainer>
            {`${priceImpactStr}%`}
        </PriceImpactTagWrap>
        <Tooltip id="tootltip_price_impact" place="bottom" style={{ backgroundColor:  'transparent', width: '258px', padding: '0', zIndex: 1}}>
            <ToolTipCom>
                Possible change in price due to the size of your transaction.
            </ToolTipCom>
        </Tooltip>
    </>
}

const WarnSvgWrap = styled(WarnSvg)`
    width: 14px;
    height: 14px;
`

const WarnTextWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    margin-left: 8px;
`

const SlippageWarnWrap = styled(Row)<{$level: number}>`
    padding: 8px 6px;
    border-radius: 6px;

    ${
        ({$level, theme}) => $level === 1 ? css`
            background-color: #F6FB79;
            ${WarnSvgWrap} {
                path, rect {
                    fill: ${theme.basicBlack}
                }
            };
            ${WarnTextWrap} {
                color: ${theme.basicBlack}
            }
        ` : $level === 2 ? css`
            background-color: #FFDD64;
            ${WarnSvgWrap} {
                path, rect {
                    fill: ${theme.basicBlack}
                }
            };
            ${WarnTextWrap} {
                color: ${theme.basicBlack}
            }
        ` : css`
            background-color: #E000E0;
            ${WarnSvgWrap} {
                path, rect {
                    fill: ${theme.basicWhite}
                }
            };
            ${WarnTextWrap} {
                color: ${theme.basicWhite}
            }
        ` 
    }
`

const PriceImpactTagWrap = styled(RowCenter)<{$level: number}>`
    font-size: 12px;
    line-height: 14px;
    padding: 4px 6px;
    position: relative;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
        background-color: #DFE0E2;
    }

    ${
        ({$level, theme}) =>  $level === 0 ? css`
            background-color: #F4F5F5;
            color: ${theme.basicBlack};
        `: $level === 1 ? css`
            background-color: #F6FB79 !important;
            color: ${theme.basicBlack} !important;
        ` : $level === 2 ? css`
            background-color: #FFDD64 !important;
            color: ${theme.basicBlack};
        ` : css`
            background-color: #E000E0 !important;
            color: ${theme.basicWhite} !important;
            &>div {
                color: ${theme.basicWhite} !important;
            }
        ` 
    }
`

export default SlippageWarnCom